import {
  ProjectRefDocument,
  ProjectRefFragment,
  ProjectRefFragmentDoc,
  ProjectRefQuery,
  ProjectRefQueryVariables,
  withStandardRefHook,
} from '@spotify/confidence-graphql';

export const useProjectRef = withStandardRefHook<
  ProjectRefQuery,
  ProjectRefFragment,
  'project',
  ProjectRefQueryVariables
>(
  ProjectRefDocument,
  'project',
  ProjectRefFragmentDoc,
  'ProjectRef',
  'CollaborationV1Project',
);
